import { api, API } from "@/lib/api";

export const fileUrl = (bookingId, fileId, inline = true) => `${API}/files/${bookingId}/${fileId}${inline ? "?inline=1" : ""}`;
export const zipUrl = (bookingId, galleryId) => `${API}/files/${bookingId}/zip?gallery_id=${encodeURIComponent(galleryId)}`;
export const mlsUrl = (bookingId, fileId) => `${API}/files/${bookingId}/${fileId}/mls`;

export async function uploadChunked(bookingId, file, galleryId, onProgress) {
  const init = await api.post(`/admin/jobs/${bookingId}/upload/init`, {
    filename: file.name, size: file.size, content_type: file.type || "application/octet-stream", gallery_id: galleryId,
  });
  const { upload_id, chunk_size } = init.data;
  const total = Math.max(1, Math.ceil(file.size / chunk_size));
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * chunk_size, Math.min(file.size, (i + 1) * chunk_size));
    let attempt = 0;
    for (;;) {
      try {
        await api.post(`/admin/jobs/${bookingId}/upload/${upload_id}/chunk?index=${i}`, blob, { headers: { "Content-Type": "application/octet-stream" }, timeout: 0 });
        break;
      } catch (e) {
        if (++attempt >= 3) throw e;
      }
    }
    onProgress?.(Math.round(((i + 1) / total) * 100));
  }
  const done = await api.post(`/admin/jobs/${bookingId}/upload/${upload_id}/complete`);
  return done.data;
}

export const fmtBytes = (n) => (n > 1e9 ? `${(n / 1e9).toFixed(2)} GB` : n > 1e6 ? `${(n / 1e6).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1e3))} KB`);
